import React, { Component } from 'react';
import './App.css';
import Results from './Results.js';
import { Search } from './Search.js';
import Toolbar from './Toolbar.js';
// import Footer from './Footer.js';

var history = new Map();

var tabs = [];
var recentSearches = [];

class App extends Component {
  constructor() {
    super();
    this.state = {
      currentQuery: '',
      nofTabs: 0,
      showResults: true,
      showNotification: true
    };
  }

  componentDidMount() {
    if(this.props.match.params.query) {
      const query = this.props.match.params.query;
      this.refs.search.selectUrlQuery( query );
    }
    if(localStorage.showNotification) {
      this.setState({showNotification: false});
    }

    // Listen for content height changes and deliver 
    // current height for iframe parent
    this.monitorContentHeight()
  }

  // Measure site height and send event to iframe parent,
  // including the current height. This is run every time 
  // the page height changes.
  monitorContentHeight = () => {
    const element = document.body
    let height;

    (function updateHeightForIframeParent() {
      if (height != element.scrollHeight) {
        height = element.scrollHeight
        try {
          // Send event to iframe parent
          window.parent.postMessage(
            {
                event: 'sab_results',
                data: {
                    height: height
                }
            }, 
            "*" // Update parent url here
          ); 
        } catch (error) {
          console.log("Error while dispatching custom event", error);
        }
      }
      if (element.heightChangeTimer) {
        clearTimeout(element.heightChangeTimer)
      }
      element.heightChangeTimer = setTimeout(updateHeightForIframeParent, 200)
    })()
  }

  history() {
    return history;
  }
  setHistory(newhistory) {
    history = newhistory
  }

  tabs() {
    return tabs;
  }
  setTabs(newTabs) {
    tabs = newTabs
  }

  recentSearches(){
    return recentSearches;
  }
  setRecentSearches(newRecentSearches) {
    recentSearches = newRecentSearches;
  }

  //Show results for requested query
  show(query) {
    //update url
    this.props.history.push(('/'+query));

    if(query === "New Search"){
      this.setState({
        currentQuery: query,
        showResults: false
      });
      //Change query in search field to empty
      this.refs.search.changeQuery('')
    }
    else {
      //Set as current query
      this.setState({
        currentQuery: query,
        showResults: true
      });
      //Pass results to Results component
      const results = history.get(query);
      for (var i = 0; i < results.length; i++){
        this.refs.results.add(results[i].source, results[i].content, query);
      }
      //Change query in search field
      this.refs.search.changeQuery(query)
    }
  }

  //if previous search is clicked in tab
  changeTab(previousSearch){
    //If search already exists in some tab
    if(tabs.indexOf(previousSearch) !== -1){
      this.show(previousSearch);
    }else{
      var current = this.state.currentQuery;
      tabs[tabs.indexOf(current)] = previousSearch;
      this.show(previousSearch);
      if(recentSearches.indexOf(current) === -1){
        history.delete(current);
      }
    }
  }

  removeTab(query) {
    //If tab is active
    if(query === this.state.currentQuery){
      const pos = tabs.indexOf(query)
      //If two tabs
      if(tabs.length === 2){
        tabs.splice(pos, 1);
        this.show(tabs[0]);
      }
      //If at least 3 tabs and
      //If tab is last, make the one before it active
      else if(tabs.length > 2 && pos === tabs.length - 1){
        tabs.splice(pos, 1);
        this.show(tabs[pos-1]);
      }
      //If tab is not last, make the one after it active
      else{
        tabs.splice(pos, 1);
        this.show(tabs[pos]);
      }
    }
    //If not active tab
    else{
      tabs.splice(tabs.indexOf(query), 1);
      this.setState({
        nofTabs: this.state.nofTabs - 1
      });
    }
    //Remove from history if not needed in previous searches
    if(recentSearches.indexOf(query) === -1){
      history.delete(query);
    }
  }

  addTab() {
    //Maximum of 5 tabs
    //Don't create empty tab if one empty exists
    if(tabs.length < 5){
      if(tabs.indexOf("New Search") === -1){
        tabs.push("New Search");
        this.setState({
          nofTabs: this.state.nofTabs + 1,
        });
      }
      this.setState({
        currentQuery: "New Search",
        showResults: false
      });
      //Change query in search field to empty
      this.refs.search.changeQuery('')
    }
  }

  hideNotification() {
    localStorage.setItem('showNotification', false);
    this.setState({
      showNotification: false
    });
  }

  render() {
    const noQuery = (this.state.currentQuery.length) ? false : true;
    const appClass = (noQuery) ? 'App is-landing' : 'App';

    return (
      <div className={appClass}>
        <div className="site-header" style={{display:"none"}}>

          <Toolbar history={history} tabs={tabs} show={this.show.bind(this)} active={this.state.currentQuery} removeTab={this.removeTab.bind(this)} addTab={this.addTab.bind(this)}/>

          <Search ref="search" search={this.onSearch.bind(this)} changeTab={this.changeTab.bind(this)} recentSearches={recentSearches} tabs={tabs} currentQuery={this.state.currentQuery}/>

          {noQuery &&
            <div className="site-header__description">
              <p><strong>Search-a-brand</strong> assists you in researching, choosing and building a brand for your company, service or product. Try it out and search with the intended name!</p>
              <div className="site-header__legal">
                <a href="/pdfs/search-a-brand-privacy_policy.pdf" target="_blank">Privacy and Cookie Policy</a>
                <a href="/pdfs/search-a-brand-terms-of-service.pdf" target="_blank">Terms of Service</a>
              </div>
            </div>
          }
        </div>

        <div className={this.state.showResults ? '' : 'hideElement'}>
          <Results ref="results" query={this.props.match.params.query ? this.props.match.params.query : ''}/>
        </div>

        {/* <Footer showNotification={this.state.showNotification}
                hideNotification={this.hideNotification.bind(this)}
                query={this.props.match.params.query ? this.props.match.params.query : ''}/> */}
      </div>
    );
  }

  handleResponse(query, response) {
    if (query === this.state.currentQuery) {
      //Add result so it shows immediately
      this.refs.results.add(response.data.source, response.data.content, query);
      //Find the query from history and add the result to its value
      history.set(query, history.get(query).concat(response.data));
      //console.log(history);
    }
    else {
      //If the result is not for the current query, see if the query
      //exists in history, and if it does, add the result to its value.
      if(history.has(query)){
        history.set(query, history.get(query).concat(response.data));
      }
    }
  }

  doSearch(query, count) {
    for (var id = 0; id < count; id += 1) {
      fetch(`/api/search?id=${id}&query=${query}`, {
        accept: 'application/json'
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.handleResponse(query, response)
        }).catch((err) => {
          if (query === this.state.currentQuery) {
            console.log(`/api/search?query=${query} failed.`);
          }
        });
    }
  }

  onSearch(text) {
    //update url
    this.props.history.push(('/'+text));

    //If this search already exists
    if(tabs.indexOf(text) !== -1){
      this.show(text);
    }
    else{
      //Show results
      this.setState({
        showResults: true
      });

      //Add the new search query to history, so the results can be saved there
      history.set(text, []);

      //Do search in current tab
      tabs[tabs.indexOf(this.state.currentQuery)] = text;

      //If this is first search
      if(this.state.nofTabs < 1){
        tabs.push(text);
        this.setState({
          nofTabs: this.state.nofTabs + 1
        });
      }

      //Clear everything
      this.refs.results.clear();
      this.setState({
        currentQuery: text
      });

      if(recentSearches.length < 5){
        recentSearches.push(text);
      }
      else{
        var last = recentSearches.shift();
        if(tabs.indexOf(last) === -1){
          history.delete(last);
        }
        recentSearches.push(text);
      }
      fetch("/api/apicount")
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const apiCount = parseInt(response, 10);
          this.doSearch(text, apiCount);
        })
        .catch((err) => {
          alert("Connection to Search A Brand server failed. Try again later.");
        });
    }
  }
}

window.mobilecheck = function () {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
  };

  export default App;



// WEBPACK FOOTER //
// ./client/src/App.js